import { render, staticRenderFns } from "./webRecommend.vue?vue&type=template&id=0675204a&scoped=true&lang=html&"
import script from "./webRecommend.vue?vue&type=script&lang=js&"
export * from "./webRecommend.vue?vue&type=script&lang=js&"
import style0 from "./webRecommend.vue?vue&type=style&index=0&id=0675204a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675204a",
  null
  
)

export default component.exports